module.exports = __webpack_public_path__ + "img/bn.c46f77e4.svg";